module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/97/assets/images/b4f887fafb11fc6353d91898f843298f.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/badges/Emerald/Emerald2.svg
// module id = yu+Z
// module chunks = 1